import { render, staticRenderFns } from "./MCLigand.vue?vue&type=template&id=27a429e5&scoped=true&"
import script from "./MCLigand.vue?vue&type=script&lang=js&"
export * from "./MCLigand.vue?vue&type=script&lang=js&"
import style0 from "./MCLigand.vue?vue&type=style&index=0&id=27a429e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a429e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCheckbox,VCol,VRow,VSlider})
